export const ACADEMY_RESET_DRAFT = 'academy/RESET_DRAFT';

export default () => ({ type: ACADEMY_RESET_DRAFT });
